<template>
    <div>
        <b-button
            variant="danger"
            @click.stop="confirmarDescomprometer()"
            v-if="tipo == 0">
            <span>
                <i class="fa fa-times-circle-o mr-2"></i> Descomprometer
            </span>
        </b-button>
    </div>
</template>

<script>

import ConveniosServicos from '../../ConveniosServicos'
export default {
    props: {
        comprometimento: {
            type: Object,
            default: () => ({})
        },

        convenio: {
            type: Object,
            default: () => ({})
        },

        tipo: {
            type: Number,
            default: () => 0
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarDescomprometer() {
            this.$swal({
                title: 'Descomprometimento',
                html: `Confirma a realização do descomprometimento no RM?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.descomprometer()
                }
            })
        },

        descomprometer() {
            this.$store.dispatch('addRequest')
            let descomprometimentoDto = {
                idContrato: this.convenio.idConvenio,
                idComprometimentoRequisicao: this.comprometimento.idComprometimentoRequisicao
            }
            ConveniosServicos.descomprometer(descomprometimentoDto).then(
                response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Descomprometido com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('atualizarCronograma')
                        } else {
                            this.$emit('atualizarErros', response.errors)
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        }
    },

    created() {},

    computed: {},

    watch: {},

    validations: {}
}
</script>
